export const ACTION_SET_SEARCH_INFO = 'actionSetSearchInfo'
